import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { VitalPlate, VitalPlateData } from '../plate';
import { SysDiaWrap } from './styles';
import { useSessionRoomState } from '../../../../context';

export const VitalSysDia: FC = () => {
  const { t } = useTranslation(['session-room']);
  const { vitalsData } = useSessionRoomState();
  const [sysDiaValue, PRValue] = useMemo(
    () => [
      `${vitalsData.bloodPressure?.Sys ?? '-'}/${vitalsData.bloodPressure?.Dia ?? '-'
      }`,
      vitalsData.bloodPressure?.Plus ?? '-',
    ],
    [vitalsData.bloodPressure]
  );

  return (
    <VitalPlate>
      <SysDiaWrap>
        <VitalPlateData
          title={t('session-room:SENSORS.SYS_DIA')}
          units="mmHg"
          value={sysDiaValue}
          style={{ flex: '1 1 0', minWidth: 0 }}
          valueStyle={{ fontSize: '56px' }}
        />
        <VitalPlateData
          title={t('session-room:SENSORS.PR')}
          units="bpm"
          value={PRValue}
          style={{ flex: '0 0 auto', width: '140px', maxWidth: '140px' }}
          extraData={[`L: ${50}`, `H: ${120}`]}
        />
      </SysDiaWrap>
    </VitalPlate>
  );
};
